import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const zakariaAnbiya: Quote = {
  id: "zakaria-anbiya-89",
  name: "Doa yang Mustahil",
  emoji: "🤲",
  category: "Doa & Dzikir",
  description:
    "Zakaria berdoa minta anak di usia tua dengan istri mandul. Allah kabulkan — karena **doa tidak punya batas waktu**.",
  detail:
    "Nabi Zakaria 'alaihissalam sudah sangat tua dan istrinya mandul. Secara logika, mustahil punya anak. Tapi beliau tetap berdoa: 'Ya Tuhanku, janganlah Engkau membiarkan aku sendiri, dan Engkau adalah **sebaik-baik Pemberi warisan**.' Allah langsung mengabulkan dengan menganugerahi Yahya. Kisah ini diabadikan dalam QS. Al-Anbiya ayat 89-90.",
  tldr: "Zakaria berdoa meski mustahil — Allah kabulkan. Doa tidak kenal terlambat.",
  story: createQuoteStory("Doa yang Mustahil", "🤲", [
    { hook: {
      title: "Pernah berdoa tapi rasanya mustahil dikabulkan?",
      body: "Rasanya sudah **terlambat**, sudah **terlalu tua**, sudah **terlalu jauh**. Tapi ada seorang nabi yang tetap berdoa di titik itu.",
    } },
    { source: {
      arabic: "رَبِّ لَا تَذَرْنِي فَرْدًا وَأَنتَ خَيْرُ الْوَارِثِينَ",
      body: "Ya Tuhanku, janganlah Engkau membiarkan aku **seorang diri**, dan Engkau adalah **sebaik-baik Pemberi warisan**.",
      title: "QS. Al-Anbiya: 89",
    } },
    { reveal: {
      body: "Zakaria sudah tua. Istrinya mandul. Secara logika, **mustahil**. Tapi dia tetap berdoa — karena yang dia minta bukan dari manusia, melainkan dari **Allah yang tidak terikat oleh mustahil**.",
    } },
    { insight: {
      title: "Apa yang istimewa dari doanya?",
      body: "Dia menyebut **kelemahannya** — \"jangan biarkan aku sendiri.\"\nDia menyebut **kebesaran Allah** — \"Engkau sebaik-baik Pemberi.\"\n\nItulah adab doa: jujur tentang kondisimu, yakin tentang kuasa-Nya.",
    } },
    { engagement: {
      title: "Ada doa yang kamu simpan karena terasa terlalu besar?",
      body: "Zakaria tidak berhenti berdoa meski seluruh dunia bilang mustahil. **Doamu tidak punya expired date.** Sampaikan saja — biar Allah yang menentukan waktunya.",
    } },
  ]),
  related: ["sabar-baqarah-153", "cukup-dunia-tirmidzi"],
};
